import {
  GestorAssignResult,
  GestorRole,
  GestorService,
  GestorServicesResult,
  GestorUpdateResult,
} from '@app/domain/models/tpv/gestor.model';
import {
  GestorAssignResponseDto,
  GestorServiceItemDto,
  GestorServicesResponseDto,
  GestorUpdateResponseDto,
} from '@app/data/dtos/tpv/gestor.dto';

function mapRole(dto: { id?: number; name?: string } | undefined): GestorRole {
  return { id: Number(dto?.id ?? 0), name: dto?.name ?? '' };
}

export function mapGestorAssignResult(dto: GestorAssignResponseDto): GestorAssignResult {
  return {
    idGestor: Number(dto.id_gestor ?? 0),
    polipayAccount: dto.polipay_account ?? '',
    service: dto.service ?? '',
    level: dto.level,
    idCompany: dto.id_company ?? null,
    sufijo: dto.sufijo ?? null,
    entity: dto.entity,
    entityType: dto.entity_type,
    role: mapRole(dto.rol),
    consumedProduct: dto.consumed_product
      ? {
          id: Number(dto.consumed_product.id ?? 0),
          productType: dto.consumed_product.product_type,
          servicio: dto.consumed_product.servicio,
          provider: dto.consumed_product.proveedor ?? null,
        }
      : undefined,
  };
}

function mapServiceItem(dto: GestorServiceItemDto): GestorService {
  return {
    idGestor: Number(dto.id_gestor ?? 0),
    idConsumedProduct: Number(dto.id_consumed_product ?? 0),
    isActive: dto.is_active === true,
    role: mapRole(dto.role),
    entityType: dto.entity_type,
    provider: dto.provider,
    service: dto.service ?? '',
  };
}

export function mapGestorServicesResult(dto: GestorServicesResponseDto): GestorServicesResult {
  return {
    polipayAccount: dto.polipay_account ?? '',
    includeInactive: dto.include_inactive === true,
    count: Number(dto.count ?? dto.services?.length ?? 0),
    services: (dto.services ?? []).map(mapServiceItem),
  };
}

export function mapGestorUpdateResult(dto: GestorUpdateResponseDto): GestorUpdateResult {
  const roleDto = dto.role ?? dto.rol;
  return {
    idGestor: Number(dto.id_gestor ?? 0),
    isActive: dto.is_active,
    role: roleDto ? mapRole(roleDto) : undefined,
  };
}
